import { Map } from 'immutable';
import { constants } from '@saucelabs/sl-module-user';

import { euAndEeaCountries } from '../../utils/countries';
import {
  CARD_DETAILS_SAVED,
  CARD_VALID_SAVED,
  FETCH_ACCOUNT,
  FETCH_BILLING_LOCATION,
  FETCH_RECURLY_TOKEN,
  PAYMENT_INFO_SAVED,
  PAYMENT_METHOD_CHANGED,
  RECURLY_COMPONENT_FETCH,
  RECURLY_COMPONENT_READY,
  SET_RECURLY_INSTANCE,
  UPDATE_ACCOUNT,
  UPDATE_BILLING_INFO,
} from './types';

const initialState = Map({
  accountInRecurlyExists: null,
  cardDetails: null,
  cardValid: null,
  email: null,
  hasPastDueInvoice: false,
  isLoading: true,
  paymentInfo: null,
  paymentInfoCurrent: null,
  paymentMethod: null,
  paymentMethodCurrent: null,
  // TODO either move to checkout or move all
  previewResponse: {
    discount: 0,
    subtotal: 0,
    total: 0,
    tax: 0,
  },
  purchaseResponse: {
    subscription_ids: [],
    invoices_ids: [],
  },
  recurlyInstance: null,
  token: '',
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_RECURLY_TOKEN.SUCCESS:
      return state.set('token', payload.id);
    case FETCH_RECURLY_TOKEN.FAILURE:
      return state.set('token', initialState.get('token'));
    case RECURLY_COMPONENT_READY:
      return state.set('isLoading', false);
    case PAYMENT_INFO_SAVED:
      return state.withMutations((newState) => {
        newState
          .set('paymentInfoCurrent', payload.billing_info)
          .set('email', payload.email);
      });
    case CARD_DETAILS_SAVED:
      return state.set('cardDetails', payload);
    case CARD_VALID_SAVED:
      return state.set('cardValid', payload);
    case PAYMENT_METHOD_CHANGED:
      return state.set('paymentMethodCurrent', payload);
    case FETCH_BILLING_LOCATION.SUCCESS:
      return state.set('recurlyInstance', payload.recurly_instance);
    case SET_RECURLY_INSTANCE: {
      const instance = euAndEeaCountries.includes(payload) ?
        constants.RECURLY_INSTANCES.EU :
        constants.RECURLY_INSTANCES.ROW;
      return state.set('recurlyInstance', instance);
    }
    case UPDATE_ACCOUNT.SUCCESS:
    case FETCH_ACCOUNT.SUCCESS: {
      const billingInfo = payload?.billing_info || {};
      const address = billingInfo?.address || {};

      const {
        email,
        has_past_due_invoice: hasPastDueInvoice,
      } = payload;
      const {
        card_type: cardType,
        company,
        exp_month: expMonth,
        exp_year: expYear,
        first_name: firstName,
        last_four: lastFour,
        last_name: lastName,
        vat_number: vatNumber,
      } = billingInfo;
      const {
        city,
        country,
        postal_code: postalCode,
        region,
        street1: address1,
        street2: address2,
      } = address;

      const paymentInfo = {
        firstName,
        lastName,
        email,
        company,
        vatNumber,
        address1,
        address2,
        city,
        country,
        postalCode,
        state: region,
      };
      const paymentMethod = cardType && {
        cardType,
        lastFour,
        expires: `${expMonth?.toString()?.padStart(2, '0')}/${expYear}`,
        isValid: true,
      };
      return state.withMutations((newState) => {
        newState.set('paymentInfo', paymentInfo)
          .set('paymentInfoCurrent', null)
          .set('email', email)
          .set('paymentMethod', paymentMethod)
          .set('paymentMethodCurrent', null)
          .set('accountInRecurlyExists', true)
          .set('hasPastDueInvoice', hasPastDueInvoice)
          .set('isLoading', false);
      });
    }
    case UPDATE_ACCOUNT.FAILURE:
      return state.set('isLoading', false);
    case FETCH_ACCOUNT.FAILURE:
      return state.withMutations((newState) => {
        newState.set('paymentInfo', initialState.get('paymentInfo'))
          .set('paymentMethod', initialState.get('paymentMethod'))
          .set('email', initialState.get('email'))
          .set('accountInRecurlyExists', false)
          .set('isLoading', false);
      });
    case UPDATE_BILLING_INFO.SUCCESS: {
      const paymentInfo = {
        firstName: payload.first_name,
        lastName: payload.last_name,
        company: payload.company,
        vatNumber: payload.vat_number,
        address1: payload.address.street1,
        address2: payload.address.street2,
        city: payload.address.city,
        country: payload.address.country,
        postalCode: payload.address.postal_code,
        state: payload.address.region,
      };

      const paymentMethod = payload.card_type && {
        cardType: payload.card_type,
        lastFour: payload.last_four,
        expires: `${payload.exp_month?.toString()?.padStart(2, '0')}/${payload.exp_month}`,
        isValid: true,
      };

      return state.withMutations((newState) => {
        newState.set('paymentInfo', paymentInfo)
          .set('paymentMethod', paymentMethod)
          .set('accountInRecurlyExists', true);
      });
    }
    case UPDATE_BILLING_INFO.FAILURE: {
      if (!state.get('accountInRecurlyExists')) {
        return state.set('accountInRecurlyExists', false);
      }
      return state;
    }
    case RECURLY_COMPONENT_FETCH:
    case UPDATE_ACCOUNT.REQUEST:
      return state.set('isLoading', true);
    default:
      return state;
  }
};
